import React, { useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { LEGAL, COMPANY } from "../data/content";
import { useLang } from "../context/LanguageContext";

const KEY_BY_SLUG = { privacy: "privacy", cookie: "cookie", termini: "terms" };

export default function Legal() {
  const { slug } = useParams();
  const nav = useNavigate();
  const { lang, toggle } = useLang();
  const key = KEY_BY_SLUG[slug];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!key) { nav("/"); return null; }
  const doc = LEGAL[lang][key];

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <div className="noise-overlay" />
      <header className="border-b border-white/10 px-6 md:px-12 h-16 flex items-center justify-between sticky top-0 bg-[#050505]/90 backdrop-blur-xl z-10">
        <Link to="/" data-testid="legal-back" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-white transition-colors">
          <ArrowLeft size={16} /> {LEGAL[lang].back}
        </Link>
        <button data-testid="legal-lang" onClick={toggle} className="text-xs font-mono uppercase tracking-widest text-zinc-400 hover:text-white border border-white/15 rounded-full px-3 py-1.5 transition-colors">
          {lang === "it" ? "IT / EN" : "EN / IT"}
        </button>
      </header>

      <main className="max-w-[820px] mx-auto px-6 md:px-12 py-20">
        <h1 data-testid="legal-title" className="font-heading font-black text-4xl md:text-5xl tracking-tight">{doc.title}</h1>
        <p className="mt-3 text-sm text-zinc-500 font-mono">{LEGAL[lang].updated}: {COMPANY.lastUpdate}</p>
        <div className="mt-10 space-y-8">
          {doc.sections.map((s, i) => (
            <section key={i} data-testid={`legal-section-${i}`}>
              <h2 className="font-heading font-bold text-xl text-white">{s.h}</h2>
              <p className="mt-2 text-zinc-400 leading-relaxed">{s.p}</p>
            </section>
          ))}
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 text-sm text-zinc-500">
          {COMPANY.name} — {COMPANY.email} — {COMPANY.phone}
        </div>
      </main>
    </div>
  );
}
